import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

import { loadHighlightTheme } from '@/lib/messageFormater';

export const useThemeStore = defineStore('theme', () => {
    const isDark = ref(false);

    const initializeTheme = () => {
        const stored = localStorage.getItem('theme');

        if (stored) {
            isDark.value = stored === 'dark';
        } else {
            // Use system preference as default
            isDark.value = window.matchMedia(
                '(prefers-color-scheme: dark)'
            ).matches;
        }

        applyTheme(isDark.value);
    };

    const applyTheme = (dark: boolean) => {
        const html = document.documentElement;
        if (dark) {
            html.classList.add('dark');
        } else {
            html.classList.remove('dark');
        }
        localStorage.setItem('theme', dark ? 'dark' : 'light');
        // Load appropriate highlight.js theme
        loadHighlightTheme(dark);
    };

    const toggleTheme = () => {
        isDark.value = !isDark.value;
    };

    watch(isDark, (newVal) => {
        applyTheme(newVal);
    });

    return {
        isDark,
        initializeTheme,
        toggleTheme,
        applyTheme
    };
});
